export interface SessionModeDefinition {
  version: number;
  placement_id: string | null;
  placement_mode: 'hybrid' | 'part_a' | 'part_b' | null;
  assessment_mode: 'hybrid' | 'part_a' | 'part_b';
  settings: { enabled: boolean; part_b_enabled: boolean } | null;
}

export class SessionModeDefinitionError extends Error {}

export function applySessionModeDefinition<T extends object>(details: T, value?: SessionModeDefinition | null): T & { session_mode_definition?: SessionModeDefinition } {
  if (value == null) return details;
  const modes = ['hybrid', 'part_a', 'part_b'];
  if (value.version !== 1 || !modes.includes(value.assessment_mode)
    || !(value.placement_mode === null || modes.includes(value.placement_mode))
    || !(value.placement_id === null || typeof value.placement_id === 'string')
    || !(value.settings === null || (typeof value.settings?.enabled === 'boolean' && typeof value.settings?.part_b_enabled === 'boolean'))) {
    throw new SessionModeDefinitionError('Session mode definition is invalid or unsupported.');
  }
  const flags = value.settings;
  const effective = flags?.enabled === false ? 'part_b' : flags?.part_b_enabled === false ? 'part_a' : value.placement_mode || 'hybrid';
  if (effective !== value.assessment_mode) throw new SessionModeDefinitionError('Session mode definition is inconsistent.');
  return { ...details, session_mode_definition: value };
}

export function settingsForSessionMode<T extends object>(details: { session_mode_definition?: SessionModeDefinition } | null | undefined, settings: T): T & { enabled?: boolean; part_b_enabled?: boolean } {
  const accepted = details?.session_mode_definition;
  return accepted ? { ...settings, enabled: accepted.assessment_mode !== 'part_b', part_b_enabled: accepted.assessment_mode !== 'part_a' } : settings;
}
